import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import ConvergenLogo from "../components/ConvergenMark";
import { describeAxiosError } from "../lib/api";

export default function AdminLogin() {
  const { t } = useLang();
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@convergen.mx");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (e) {
      setError(describeAxiosError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-pearl px-4" data-testid="page-admin-login">
      <div className="w-full max-w-md bg-white border border-rule p-10">
        <div className="flex flex-col items-center mb-10">
          <ConvergenLogo size={88} />
        </div>
        <div className="flex items-center gap-3 mb-6">
          <Lock className="w-4 h-4 text-cerulean" strokeWidth={1.5} />
          <span className="text-[11px] font-mono tracking-[0.22em] uppercase text-cerulean">{t.admin.login_title}</span>
        </div>
        <h1 className="display-heading text-2xl">{t.admin.login_sub}</h1>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <span className="block text-[11px] font-mono tracking-[0.22em] uppercase text-text-muted mb-2">{t.admin.email}</span>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none h-11 border-rule focus:border-cerulean" required />
          </label>
          <label className="block">
            <span className="block text-[11px] font-mono tracking-[0.22em] uppercase text-text-muted mb-2">{t.admin.password}</span>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none h-11 border-rule focus:border-cerulean" required />
          </label>

          {error && <div className="text-sm text-red-600" data-testid="admin-error">{error}</div>}

          <Button
            type="submit"
            data-testid="admin-login-btn"
            disabled={loading}
            className="w-full bg-ink hover:bg-cerulean text-white rounded-none h-11 text-[12px] tracking-[0.18em] uppercase font-medium transition-colors disabled:opacity-40"
          >
            {loading ? "…" : t.admin.enter}
          </Button>
        </form>
      </div>
    </div>
  );
}
